// Das Etikett für den Zustand eines Mandats — in Zuordnungen, Mandaten und im Lauf dasselbe.
import { TonBadge } from "@/components/mitglieder/status-badge";
import type { Ton } from "@/lib/labels";
import type { MandatsLage } from "@/lib/beitraege/views";

export const MANDATS_LAGE: Record<MandatsLage, { label: string; ton: Ton }> = {
  gueltig: { label: "Gültig", ton: "success" },
  fehlt: { label: "Mandat fehlt", ton: "danger" },
  unvollstaendig: { label: "Unvollständig", ton: "warning" },
  widerrufen: { label: "Widerrufen", ton: "danger" },
  verfallen: { label: "Verfallen", ton: "warning" },
};

export function MandatsLageBadge({ lage }: { lage: MandatsLage }) {
  const l = MANDATS_LAGE[lage];
  return <TonBadge ton={l.ton}>{l.label}</TonBadge>;
}
